/* This file was automatically generated - please modify the template not this file! */

import * as moment from "moment";

import { OrgStructure } from "../orgStructure";

import * as actions from "./actiontypes";
import { EmployeeRecordAction } from "./actions";

export function OrgStructuresReducerDropDownOne(state: OrgStructure[] = [], action: EmployeeRecordAction): OrgStructure[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_ONE:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        default:
            return state;
    }
}

export function OrgStructuresReducerDropDownTwo(state: OrgStructure[] = [], action: EmployeeRecordAction): OrgStructure[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_TWO:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        default:
            return state;
    }
}

export function OrgStructuresReducerDropDownThree(state: OrgStructure[] = [], action: EmployeeRecordAction): OrgStructure[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_THREE:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        default:
            return state;
    }
}

export function OrgStructuresReducerDropDownFour(state: OrgStructure[] = [], action: EmployeeRecordAction): OrgStructure[] {
    switch (action.type) {
        case actions.LOAD_ORGSTRUCTURES_SEARCH_SUCCESS_FOUR:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        default:
            return state;
    }
}
